<div class="customer-panel">
    <!-- Readonly Mode -->
    <div *ngIf="!isEditMode" class="readonly-view">
        <div class="panel-content">
            <div class="header">
                <h3>{{ editCustomer?.name || '-' }}</h3>
                <p>{{ editCustomer?.organizationNo || '-' }}</p>
            </div>

            <div class="box">
                <div class="title">
                    <span class="material-symbols-rounded" aria-hidden="true">distance</span>
                    <h5>{{ 'FEATURES.CUSTOMER.ADDRESS' | translate }}</h5>
                </div>
                <p>{{ editCustomer?.address || '-' }}</p>
                <p>{{ editCustomer?.zipCode || '-' }} {{ editCustomer?.city || '-' }}</p>
                <p>{{ editCustomer?.country || '-' }}</p>
            </div>

            <div class="box">
                <div class="title">
                    <span class="material-symbols-rounded" aria-hidden="true">person</span>
                    <h5>{{ 'FEATURES.CUSTOMER.RESPONSIBLE' | translate }}</h5>
                </div>
                <p>{{ responsibleName$ | async }}</p>
            </div>

            <div class="form-actions">
                <button type="button" (click)="enterEditMode()">
                    {{ 'BUTTONS.EDIT' | translate }}
                </button>
            </div>
            <div class="meta">
                {{ 'GENERAL.CREATED' | translate }}:
                {{ editCustomer?.created | dateTime: 'yyyy-MM-dd' | replaceEmptyString }}
            </div>
        </div>
    </div>

    <!-- Edit Mode -->
    <div *ngIf="isEditMode" class="edit-view">
        <form [formGroup]="customerForm" (ngSubmit)="saveAndExitEdit()">
            <div class="panel-content" [class.loading]="loading">
                <app-form-section>
                    <app-form-row>
                        <app-form-group>
                            <label for="name">{{ 'FEATURES.CUSTOMER.NAME' | translate }}</label>
                            <input
                                appInputValidator
                                [checkValidity]="showPotentialValidationMessages"
                                id="name"
                                formControlName="name"
                                type="text"
                                [placeholder]=""
                            />
                            <app-validation-message
                                *ngIf="showPotentialValidationMessages && isEditMode"
                                [control]="f.name"
                                languageKey="FEATURES.CUSTOMER.NAME"
                            />
                        </app-form-group>
                    </app-form-row>
                    <app-form-row>
                        <app-form-group>
                            <label for="organizationNo">{{ 'FEATURES.CUSTOMER.ORGNO' | translate }}</label>
                            <input
                                appInputValidator
                                [checkValidity]="showPotentialValidationMessages"
                                id="organizationNo"
                                formControlName="organizationNo"
                                type="text"
                                [placeholder]=""
                            />
                            <app-validation-message
                                *ngIf="showPotentialValidationMessages && isEditMode"
                                [control]="f.organizationNo"
                                languageKey="FEATURES.CUSTOMER.ORGNO"
                            />
                        </app-form-group>
                    </app-form-row>
                    <app-form-row>
                        <app-form-group>
                            <label for="address">{{ 'FEATURES.CUSTOMER.ADDRESS' | translate }}</label>
                            <input
                                appInputValidator
                                [checkValidity]="showPotentialValidationMessages"
                                id="address"
                                formControlName="address"
                                type="text"
                                [placeholder]=""
                            />
                            <app-validation-message
                                *ngIf="showPotentialValidationMessages && isEditMode"
                                [control]="f.address"
                                languageKey="FEATURES.CUSTOMER.ADDRESS"
                            />
                        </app-form-group>
                    </app-form-row>
                    <app-form-row>
                        <app-form-group>
                            <label for="zipCode">{{ 'FEATURES.CUSTOMER.ZIPCODE' | translate }}</label>
                            <input
                                appInputValidator
                                [checkValidity]="showPotentialValidationMessages"
                                id="zipCode"
                                formControlName="zipCode"
                                type="text"
                                [placeholder]=""
                            />
                            <app-validation-message
                                *ngIf="showPotentialValidationMessages && isEditMode"
                                [control]="f.zipCode"
                                languageKey="FEATURES.CUSTOMER.ZIPCODE"
                            />
                        </app-form-group>
                        <app-form-group>
                            <label for="city">{{ 'FEATURES.CUSTOMER.CITY' | translate }}</label>
                            <input
                                appInputValidator
                                [checkValidity]="showPotentialValidationMessages"
                                id="city"
                                formControlName="city"
                                type="text"
                                [placeholder]=""
                            />
                            <app-validation-message
                                *ngIf="showPotentialValidationMessages && isEditMode"
                                [control]="f.city"
                                languageKey="FEATURES.CUSTOMER.CITY"
                            />
                        </app-form-group>
                    </app-form-row>
                    <app-form-row>
                        <app-form-group>
                            <label for="country">{{ 'FEATURES.CUSTOMER.COUNTRY' | translate }}</label>
                            <input
                                appInputValidator
                                [checkValidity]="showPotentialValidationMessages"
                                id="country"
                                formControlName="country"
                                type="text"
                                [placeholder]=""
                            />
                            <app-validation-message
                                *ngIf="showPotentialValidationMessages && isEditMode"
                                [control]="f.country"
                                languageKey="FEATURES.CUSTOMER.COUNTRY"
                            />
                        </app-form-group>
                    </app-form-row>
                    <app-form-row>
                        <app-form-group>
                            <label for="responsibleId">{{ 'FEATURES.CUSTOMER.RESPONSIBLE' | translate }}</label>
                            <app-dropdown [items]="users$ | async" formControlName="responsibleId" />
                            <!-- <app-validation-message
                                *ngIf="showPotentialValidationMessages && isEditMode"
                                [control]="f.responsibleId"
                                languageKey="FEATURES.CUSTOMER.RESPONSIBLE"
                            /> -->
                        </app-form-group>
                    </app-form-row>
                </app-form-section>

                <div class="form-actions">
                    <button type="button" (click)="cancelEdit()">
                        {{ 'BUTTONS.CANCEL' | translate }}
                    </button>
                    <button type="submit" class="primary" [class.loading]="loading" [disabled]="isDisabled()">
                        {{ 'BUTTONS.SAVE' | translate }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
